/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/messaging/connectors/msteams/MSTeamsAuth',['../../../lib/@waca/core-client/js/core-client/ui/core/Class', '../../../nls/StringResources'], function (Class, StringMessages) {
	'use strict';

	var MSTeamsAuth = Class.extend( /** @lends MSTeamsAuth */{

		/**
   * @desc Constructor for MSTeamsAuth.
   * @constructs MSTeamsAuth
   * @extends Class
   * @public
   * @param {object} glassContext - the Glass context, mandatory
   * @returns an object for MS Teams authentication operations
   *
   * @example var msTeamsAuth = new MSTeamsAuth(glassContext);
   */
		init: function init(glassContext) {
			MSTeamsAuth.inherited('init', this, arguments);
			this.glassContext = glassContext;
		},

		/**
   * Authenticates the user in MS Teams.
   * @instance
   * @returns {object} a JSON object
   */
		authWithTeams: function authWithTeams() {
			return Promise.reject(new Error(StringMessages.get('error_not_implemented')));
		}

	});

	return MSTeamsAuth;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

